import React, { useState, ReactElement } from "react";
import styled from "@emotion/styled/macro";

import closeIcon from "../res/i_close.svg";
import { TRANSITION_DURATION } from "./DialogRoot";
import { Transition } from "react-transition-group";

const inOpacity = 0.8;

const defaultStyle = {
  transition: `background-color ${TRANSITION_DURATION}ms ease-in-out`,
  backgroundColor: `rgba(32, 33, 39, 0)`
};

const transitionStyles = {
  entering: {
    backgroundColor: `rgba(32, 33, 39, ${inOpacity})`
  },
  entered: { backgroundColor: `rgba(32, 33, 39, ${inOpacity})` },
  exiting: { backgroundColor: `rgba(32, 33, 39, 0)` },
  exited: { backgroundColor: `rgba(32, 33, 39, 0)` },
  unmounted: {}
};

const Root = styled("div")`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 80px;
  z-index: 1;
`;

const CloseButton = styled("button")`
  border: none;
  background: url(${closeIcon}) no-repeat center center;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
`;

interface IProps {
  onClose?: () => void;
  children: ReactElement;
}

export default function DialogOverlay({ children, onClose }: IProps) {
  const [isOpen, setIsOpen] = useState(true);

  const close = () => {
    setIsOpen(false);
    setTimeout(() => {
      if (onClose) {
        onClose();
      }
    }, TRANSITION_DURATION);
  };

  return (
    <>
      <Transition in={isOpen} timeout={TRANSITION_DURATION} appear>
        {state => (
          <Root
            onTouchStart={event => event.stopPropagation()}
            onTouchMove={event => event.stopPropagation()}
            onMouseMove={event => event.stopPropagation()}
            onMouseDown={event => event.stopPropagation()}
            onClick={event => {
              event.stopPropagation();
              close();
            }}
            style={{
              ...defaultStyle,
              ...transitionStyles[state]
            }}
          >
            {React.cloneElement(children, { isOpen })}
          </Root>
        )}
      </Transition>
      {onClose && <CloseButton onClick={close} />}
    </>
  );
}
